import React from "react";

import { withStyles } from '@material-ui/styles';
import withCurrentUser from '../../../hocs/with_current_user.js.jsx';
import withShowToast from '../../../hocs/with_show_toast.js.jsx';
import withKeepNavigationState from "../../../hocs/with_keep_navigation_state.js";
import { compose } from 'redux';

import I18n from "../../../base/i18n.js.jsx";

import HtmlContent from "../../../base/components/html_content.js";

import FormFields from "../../../base/form/form_fields.js.jsx";
import Button from "../../../base/buttons/button.js.jsx";
import Checkbox from "../../../base/inputs/checkbox.js";
import BackButton from "../../../base/buttons/back_button.js";

import BaseSessionPage from "./components/base_session_page.js.jsx";
import SignInNav from "./components/sign_in_nav.js";

import { SignInInfoModel } from "../../../models/session/sign_in_info_model.js.jsx";

import RegisterUseCase from "../../../use_cases/sessions/register_use_case.js.jsx";

import Routes from "../../routes.js";

import Analytics, { NewsletterSourceRegistration } from "../../../utils/analytics";

const styles = theme => ({
  agreementRow: {
    marginTop: "32px",
    alignItems: "flex-start",
     ['@media (max-width: 768px)']: {
      marginTop: "30px",
    },
    "& .MuiCheckbox-root": {
      marginTop: "-9px"
    },
    "& .MuiFormControlLabel-label": {
      ['@media (max-width: 768px)']: {
        fontSize: "11px"
      }
    },
    color: theme.palette.grayText,
    fontSize: "16px",
    "& a": {
      color: theme.palette.grayText,
    }
  },
  button: {
    margin: "16px 0px",
    width: "100%",
    ['@media (max-width: 768px)']: {
      margin: "40px 0 45px",
    },
  },
  text: {
    display: "block",
    fontSize: "24px",
    fontWeight: theme.typography.fontWeightLight,
    marginBottom: "70px"
  },
  signInContainer: {
    display: "flex",
    justifyContent: "flex-end"
  },
  companyText: {
    color: theme.palette.grayText,
    fontSize: "12px",
    lineHeight: "1.6",
    marginBottom: "35px",
    "& a": {
      color: theme.palette.grayText,
    },
    ['@media (max-width: 768px)']: {
      fontSize: "11px"
    }
  }
});

const ErrorCodeRegistrationCompleted = "registrations.completed";

class SignUpPage extends React.Component {

  constructor(props) {
    super(props);

    const { navigationState: { projectId, projectSlug } = {} } = props;

    this.signInInfo = {
      agreeToSubscribe: false,
      projectId: projectId,
      projectSlug: projectSlug
    }

    this.state = {
      ...this.state,
      formFields: this.fieldsForStep()
    };

    this.onItemChange = this.onItemChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onComeBack = this.onComeBack.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentUser: prevUser } = prevProps
    const { currentUser } = this.props;

    if(!prevUser && currentUser) {
      this.onComeBack();
    }
  }

  onItemChange(changedItem) {
    this.signInInfo = {
      ...this.signInInfo,
      ...changedItem
    }
  }

  onSubmit(event) {
    event.preventDefault();

    if(!this.allowToSubmit()) {
      return;
    }
    this.setState({
      submit: true,
      errorData: undefined
    });

    RegisterUseCase.execute(this.signInInfo)
    .then((result) => {
      const { data: { user } } = result;
      const { loadUser, history } = this.props;
      loadUser();
      Analytics.registrationRequested(user);
      if(this.signInInfo.agreeToSubscribe) {
        Analytics.subscribedToNewsletter(this.signInInfo.email, NewsletterSourceRegistration)
      }
      history.replace(Routes.registration());
    })
    .catch((result) => {
      const { errorCode, errorData } = result;
      const { navigationState } = this.props;

      if(errorCode === ErrorCodeRegistrationCompleted) {
        const { history, loadUser, showWarningMessage } = this.props;
        const { email } = this.signInInfo;
        const { message } = result;
        loadUser();
        history.replace({
          pathname: Routes.signIn(),
          search: `?email=${email}`,
          state: navigationState
        });
        showWarningMessage(message);
      }
      else {
        this.setState({
          submit: false,
          errorData: errorData
        });
        this.props.showServerErrorIfNeed(result);
      }
    });
    return;
  }

  onComeBack() {
    const { history } = this.props;
    if(history.length > 2) {
      history.goBack()
    }
    else {
      history.replace(Routes.index())
    }
  }

  fieldsForStep() {
    let fields = SignInInfoModel.formFields();
    let whiteList = ["email"];
    return fields.filter((field) => whiteList.includes(field.name));
  }

  render() {
    return <BaseSessionPage >
      <SignInNav />
      <form onSubmit = { this.onSubmit } >
        { this.form() }
      </form>
    </BaseSessionPage>
  }

  form() {
    const { classes } = this.props;

    const { formFields, submit, errorData } = this.state;

    const { signInInfo } = this;

    return <React.Fragment>
      <FormFields formFields = { formFields }
                  item = { signInInfo }
                  errorData = { errorData }
                  onItemChange = { this.onItemChange }
                  defaultWeight = { 12 } />
      <Checkbox checked = { this.signInInfo.agreeToSubscribe }
                onChange = { (value) => this.onItemChange({ agreeToSubscribe: value }) }
                className = { classes.agreementRow }
                displayName = {
                  <HtmlContent>
                    { I18n.t("web.subscription.sign_up_agreement", {data_protection: Routes.dataProtection()}) }
                  </HtmlContent>
                }/>
      <Button className = { classes.button }
              type = { "submit" }
              disabled = { submit } >
        { I18n.t("shared.sign_up") }
      </Button>
      {/* <HtmlContent className = { classes.companyText }>
        { I18n.t("web.page.sign_up.company_invest")}
      </HtmlContent> */}
      {/* <div className = { classes.backContainer }>
        <BackButton />
      </div> */}
    </React.Fragment>
  }

  allowToSubmit() {
    return true;
  }
}

export default compose(withKeepNavigationState, withShowToast, withCurrentUser, withStyles(styles))(SignUpPage)
